import type { CalculateOffersPerson } from '@/services/inventory-api.service';
import type { SkierCounts } from '@/store/book-ski-pass.store';
import { getBirthDateFromRestriction, type DomainRestriction } from '@/utils/domain-restrictions';

export function buildAgeMapFromRestrictions(
  restrictions: DomainRestriction[] | undefined
): Record<string, number> {
  const ageRestrictions = restrictions?.filter((r) => r.type === 'age') ?? [];
  const map: Record<string, number> = {};
  for (const r of ageRestrictions) {
    const key = r.name.trim();
    if (!key) continue;
    const from = typeof r.from === 'number' ? r.from : undefined;
    const to = typeof r.to === 'number' ? r.to : undefined;
    map[key] = from != null && to != null ? Math.round((from + to) / 2) : (from ?? to ?? 30);
  }
  return map;
}

export function buildBirthDateMapFromRestrictions(
  restrictions: DomainRestriction[] | undefined,
  referenceDate?: string | null
): Record<string, string> {
  const relevant = restrictions?.filter((r) => r.type === 'age' || r.type === 'date') ?? [];
  const map: Record<string, string> = {};
  for (const r of relevant) {
    const key = r.name.trim();
    if (!key) continue;
    const birthDate = getBirthDateFromRestriction(r, referenceDate);
    if (birthDate) map[key] = birthDate;
  }
  return map;
}

export function buildPeopleFromSkierCounts(
  skierCounts: SkierCounts,
  startDate: string,
  days: number,
  ageMap: Record<string, number>,
  birthDateMap: Record<string, string>
): CalculateOffersPerson[] {
  const people: CalculateOffersPerson[] = [];

  for (const [key, count] of Object.entries(skierCounts)) {
    if (count <= 0) continue;
    const birthDate = birthDateMap[key];
    const age = ageMap[key] ?? 30;
    for (let i = 0; i < count; i++) {
      if (birthDate) {
        people.push({ startDate, days, birthDate });
      } else {
        people.push({ startDate, days, age });
      }
    }
  }

  return people;
}
